import PortalIdParser from 'PortalIdParser';
import getIn from 'transmute/getIn';
import { getIsCallIncoming, getShouldShowActiveCallState } from 'calling-internal-common/widget-status/operators/getCallState';
import { getCallStatus } from 'calling-cross-tab-library/appData/operators/widgetDetailsOperators';
import { getData } from 'calling-lifecycle-internal/async-flux-utils/operators/getApiProperties';
import { CommunicatorLogger } from 'calling-lifecycle-usage-tracker/callingTracker';
import InboundCallingTracker from 'calling-lifecycle-usage-tracker/inboundCallingTracker';
import { getPropertyName, getObjectId, getObjectTypeId, getPhoneNumberProperties, getMetadata } from 'calling-lifecycle-internal/callees/operators/calleesOperators';
// @ts-expect-error not typed
import SearchableCalleeList from 'calling-ui-library/callee-select/components/SearchableCalleeList';
// @ts-expect-error module not typed
import CurrentSettingsInfoWorkspace from './CurrentSettingsInfoWorkspace';
import { getCallableObjectAndAssociations } from 'calling-lifecycle-internal/callee-omnibus/operators/calleeOmnibusResultGetters';
import { useWidgetDetails } from 'calling-cross-tab-library/external/useWidgetDetails';
import { getStandaloneConnectionId } from 'calling-cross-tab-library/appData/operators/widgetDetailsOperators';
import { sendCrossTabMessage } from 'calling-cross-tab-library/external/sendCrossTabMessage';
import { createInitiateOutboundCallMessage } from 'calling-lifecycle-messages/deviceEventCreators';
import { getAccountTypeFromPhoneNumber } from 'calling-ui-library/utils/getAccountTypeFromPhoneNumber';
import { getCallTabUrl } from '../../utils/getCallTabUrl';
import { callingWindowUrl } from 'calling-lifecycle-internal/utils/urlUtils';
import { INITIATE_OUTBOUND_CALL_MESSAGE } from 'calling-lifecycle-messages/deviceEventConstants';
import { logCallingError } from 'calling-error-reporting/report/error';
import { CALL_FROM_BROWSER } from 'calling-internal-common/constants/CallMethods';
import { getIsMinutesUsageOverLimit } from 'calling-lifecycle-internal/calls-v1-settings-usage/operators/MinuteUsageSummaryGetters';
import { useMemo, useState } from 'react';
import { CallSource } from 'calling-cross-tab-library/constants/CallSource';
import { INBOX } from 'calling-internal-common/constants/appIdentifiers';
import { PhoneNumberSources } from 'calling-internal-common/constants/PhoneNumberSources';
import { hasPaidSeatAccess } from 'calling-orchestration-shared-library/hub-info/utils/hasCallingFeature';
import { View } from 'foundations-components/components/View';
import { getIsTwilioBasedCallProvider } from 'calling-lifecycle-internal/call-provider/operators/getIsTwilioBasedCallProvider';
import { setPersistedCallMethod } from 'calling-lifecycle-internal/utils/getLocalCallSettings';
import { Spacer } from 'foundations-components/components/Spacer';
import ChangeProviderButtonWrapper from './ChangeProviderButtonWrapper';
import { CALLEE_NUMBERS } from 'calling-integration-sdk-support/viewport/constants/changeProviderButtonLocations';
import { getHubSpotCallingEnabled, getInstalledCallingApplications, getPhoneNumbers } from '../../callee-omnibus/operators/settingsOmnibusResultGetters';
import { getHasMultipleProviders } from '../utils/getHasMultipleProviders';
import { CALL_WINDOW_HEIGHT_WITHOUT_PX, CALL_WINDOW_WIDTH_WITHOUT_PX } from 'calling-ui-library/calling-remote-redesign/constants/BaseLayoutDimensions';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CallSettingsNumbersWorkspace = props => {
  const {
    appIdentifier,
    defaultFromNumber,
    channelAssignedPhoneNumbers,
    isKnownVisitor,
    visitorPhoneNumber,
    ticketId,
    threadId,
    gates
  } = props;
  const {
    widgetDetails
  } = useWidgetDetails();
  const activeConnectionId = getStandaloneConnectionId(widgetDetails);
  const activeCallTabOpen = Boolean(activeConnectionId);
  const crossTabCallStatus = getCallStatus(widgetDetails);
  const isMinutesUsageOverLimit = getIsMinutesUsageOverLimit(props.minutesUsage);
  const defaultFromNumberRecord = channelAssignedPhoneNumbers.size === 1 ? channelAssignedPhoneNumbers.get(0) :
  // use latest number that was used to call or be called
  channelAssignedPhoneNumbers.find(number => number.get('phoneNumber') === defaultFromNumber);
  const [selectedFromNumber, setSelectedFromNumber] = useState(defaultFromNumberRecord);
  const isInbox = appIdentifier === INBOX;
  const source = isInbox ? CallSource.INBOX : CallSource.HELP_DESK;
  const openCallTabAndStartOutboundCall = ({
    callableObject,
    toNumber,
    fromNumber,
    accountType,
    requireContactOrCompany
  }) => {
    const portalId = PortalIdParser.get();
    const trimmedCallableObject = {
      objectId: getObjectId(callableObject),
      objectTypeId: getObjectTypeId(callableObject),
      crmObjectSubscriptionStatus: getIn(['crmObjectSubscriptionStatus'], callableObject)
    };
    setPersistedCallMethod(CALL_FROM_BROWSER);
    if (props.isUngatedForRedesign) {
      const queryString = `action=${INITIATE_OUTBOUND_CALL_MESSAGE}&callMethod=${CALL_FROM_BROWSER}&callableObject=${JSON.stringify(trimmedCallableObject)}&fromNumber=${fromNumber}&toNumber=${toNumber}&source=${source}&requireContactOrCompany=${requireContactOrCompany}&threadId=${threadId}`;
      window.open(callingWindowUrl(PortalIdParser.get() || '', queryString), 'calling-window', `menubar=no,resizable=no,scrollbars=yes,location=no,width=${CALL_WINDOW_WIDTH_WITHOUT_PX},height=${CALL_WINDOW_HEIGHT_WITHOUT_PX}`);
    } else {
      const queryString = `action=${INITIATE_OUTBOUND_CALL_MESSAGE}&callableObject=${JSON.stringify(trimmedCallableObject)}&fromNumber=${fromNumber}&toNumber=${toNumber}&source=${source}&accountType=${accountType}&requireContactOrCompany=${requireContactOrCompany}&threadId=${threadId}`;
      window.open(getCallTabUrl(portalId, queryString), 'calling-window', 'menubar=no,resizable=yes,scrollbars=no,location=no,width=740,height=750');
    }
  };
  const startOutboundCall = ({
    numberIdentifier,
    callableObject
  }) => {
    const numberPropertyName = getPropertyName(numberIdentifier);
    const phoneNumberProperties = getPhoneNumberProperties(callableObject);
    const propertyToCall = getIn([numberPropertyName], phoneNumberProperties) || null;
    const phoneNumberMetadata = propertyToCall && getMetadata(propertyToCall);
    const toNumber = phoneNumberMetadata.toNumberString;
    const fromNumber = getIn(['phoneNumber'], selectedFromNumber);
    const fromNumberSource = getIn(['source'], selectedFromNumber);
    const accountType = getAccountTypeFromPhoneNumber(selectedFromNumber);
    const callProvider = fromNumberSource === PhoneNumberSources.CONNECT_NUMBER ? 'Twilio' : 'Hubspot';
    const isChannelConnectedFromNumber = !!getIn(['workspaceIdAndType'], selectedFromNumber);
    const callableObjectJS = callableObject.toJS();
    const _callableObject = {
      crmObjectSubscriptionStatus: callableObjectJS.crmObjectSubscriptionStatus,
      objectId: callableObjectJS.objectId,
      objectTypeId: callableObjectJS.objectTypeId
    };
    if (fromNumber) {
      CommunicatorLogger.log('callUsage_startCall', {
        action: 'start call',
        callMedium: 'CALLING_PAGE_UI',
        provider: callProvider,
        source: appIdentifier,
        phoneNumberType: fromNumberSource,
        isChannelConnectedFromNumber,
        ticketId,
        threadId
      });
      InboundCallingTracker.trackCallTabStartOutboundCall({
        appIdentifier
      });
      if (activeCallTabOpen) {
        sendCrossTabMessage(createInitiateOutboundCallMessage({
          destinationConnectionId: activeConnectionId,
          callableObject: _callableObject,
          toNumber,
          fromNumber: fromNumber,
          source,
          accountType,
          // not needed for redesign
          requireContactOrCompany: isKnownVisitor,
          threadId
        })).catch(error => {
          logCallingError({
            error,
            tags: {
              requestName: 'sendCrossTabMessage - initiate outbound call'
            }
          });
        });
      } else {
        openCallTabAndStartOutboundCall({
          callableObject: _callableObject,
          toNumber,
          fromNumber: fromNumber,
          accountType,
          requireContactOrCompany: isKnownVisitor
        });
      }
      props.onCallButtonClick();
    }
  };
  const {
    asyncCalleeOmnibus,
    widgetState,
    selectedCallProvider,
    asyncSettingsOmnibus
  } = props;
  const calleeOmnibusData = getData(asyncCalleeOmnibus);
  const calleesData = calleeOmnibusData && getCallableObjectAndAssociations(calleeOmnibusData);
  const shouldShowActiveWidgetCallState = getShouldShowActiveCallState(widgetState.get('callStatus'));
  const isFreeCalling = !hasPaidSeatAccess();
  const isCrossTabCallStatusActive = getShouldShowActiveCallState(crossTabCallStatus) || getIsCallIncoming(crossTabCallStatus);
  const disabledTooltipMessage = !selectedFromNumber ? 'callSettingsOptions.noSelectedFromNumber' : isFreeCalling ? 'callSettingsOptions.freeSeatHubSpotCallingBlocked' : isMinutesUsageOverLimit ? `callSettingsOptions.minutesUsageOverLimit` : isCrossTabCallStatusActive || shouldShowActiveWidgetCallState ? 'callSettingsOptions.callActiveOutboundCallBlocked' : null;
  const settingsOmnibusData = getData(asyncSettingsOmnibus);
  const installedCallingApplications = getInstalledCallingApplications(settingsOmnibusData);
  const hasMultipleProviders = useMemo(() => getHasMultipleProviders({
    installedCallingApplicationsLength: (installedCallingApplications === null || installedCallingApplications === void 0 ? void 0 : installedCallingApplications.length) || 0,
    fromNumbers: getPhoneNumbers(settingsOmnibusData),
    isHubSpotEnabled: getHubSpotCallingEnabled(selectedCallProvider)
  }), [installedCallingApplications, settingsOmnibusData, selectedCallProvider]);
  return /*#__PURE__*/_jsxs(View, {
    maxBlockSize: "400px",
    overflow: "auto",
    as: "div",
    children: [/*#__PURE__*/_jsx(SearchableCalleeList, {
      appIdentifier: appIdentifier,
      calleesData: calleesData,
      onSelectToNumber: startOutboundCall,
      disabled: !!disabledTooltipMessage,
      canEdit: false,
      showAddPropertyButton: false,
      disabledTooltipMessage: disabledTooltipMessage,
      isKnownVisitor: isKnownVisitor,
      visitorPhoneNumber: visitorPhoneNumber
    }), /*#__PURE__*/_jsxs(View, {
      position: "sticky",
      insetBlockEnd: "0px",
      backgroundColor: "fill-surface-default",
      borderBlockStartWidth: "200",
      borderBlockStartStyle: "solid",
      borderBlockStartColor: "border-core-disabled",
      as: "div",
      children: [/*#__PURE__*/_jsx(CurrentSettingsInfoWorkspace, {
        selectedCallProvider: selectedCallProvider,
        selectedFromNumber: selectedFromNumber,
        handleSelectFromNumber: setSelectedFromNumber,
        channelAssignedPhoneNumbers: channelAssignedPhoneNumbers,
        defaultPhoneNumber: defaultFromNumber,
        appIdentifier: appIdentifier,
        showFromNumberDropdown: getIsTwilioBasedCallProvider(selectedCallProvider)
      }), hasMultipleProviders && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(ChangeProviderButtonWrapper, {
          providerName: selectedCallProvider.name,
          location: CALLEE_NUMBERS,
          gates: gates
        }), /*#__PURE__*/_jsx(Spacer, {
          space: "100"
        })]
      })]
    })]
  });
};
export default CallSettingsNumbersWorkspace;